import type { PrintProps } from '../Print.types';
import type { PrintQueriesHandlers } from './usePrintQueriesHandlers.types';

import * as constants from '../Print.constants';
import * as queryKeys from 'constants/QueryKeys';
import * as errorUtils from 'utils/errors';

import { useQuery } from '@tanstack/react-query';
import { useDocumentsApi } from 'shared/features/documents/hooks';

export const usePrintQueries = ({
  props,
  events
}: {
  props: Pick<PrintProps, 'documentIds' | 'queryOptions'>;
  events: {
    onDocumentsFetchSuccess: PrintQueriesHandlers['handleDocumentsFetchSuccess'];
  };
}) => {
  const documentsApi = useDocumentsApi();

  const fetchDocuments = useQuery({
    enabled: false,
    queryKey: [
      ...queryKeys.COMPLEX_QUERY_KEY_GETTERS[queryKeys.QUERY_KEYS.DOCUMENTS][
        queryKeys.QUERY_SECTIONS.PRINT_ACTION
      ](props.documentIds, props.queryOptions?.extraQueryKey)
    ],
    queryFn: async () => {
      try {
        const data = await documentsApi.fetchDocuments({
          doc_id: props.documentIds,
          exclusive_fields: constants.EXCLUSIVE_FIELDS,
          limit: props.documentIds.length
        });
        events.onDocumentsFetchSuccess(data);
        return data;
      } catch (error) {
        errorUtils.logReactQueryError(error as Error);
        throw error;
      }
    },
    retry: false,
    refetchOnWindowFocus: false
  });

  return {
    fetchDocuments
  };
};
